import axios from '@/utils/axios'
// import qs from 'qs';
// 设置默认请求头（可以在应用初始化时设置一次）
/**
 * 公告接口
 */
export default {
  /**
   * 公告列表
   * @returns 
   */
  noticeList: async () => {
    try {
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      const response = await axios.get(`${process.env.VUE_APP_BASE_API}/spectral-api/api/notice/list`,
      );
      return response.data;
    } catch (error) {
      console.log(error)
    }
  },
  /**
   * 获取详情
   * @param {*} data 
   * @returns 
   */
  noticeInfo: async (data) => {
    try {
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      const response = await axios.get(`${process.env.VUE_APP_BASE_API}/spectral-api/api/notice/info?id=${data}`,
      );
      return response.data;
    } catch (error) {
      console.log(error)
    }
  },
  openwebtermsofserviceList: async () => {
    try {
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      const response = await axios.get(`${process.env.VUE_APP_BASE_API}/spectral-api/api/termsofservice/list`,
      );
      return response.data;
    } catch (error) {
      console.log(error)
    }
  },
  openwebtermsofserviceInfo: async (data) => {
    try {
      axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
      const response = await axios.get(`${process.env.VUE_APP_BASE_API}/spectral-api/api/termsofservice/info?id=${data}`,
      );
      return response.data;
    } catch (error) {
      console.log(error)
    }
  },
}